import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";
import { CreateRefRegulerResponse, CreateRegRegulerRequest, DataRegistration, GetsRegRegulerRequest, GetsRegRegulerResponse } from "./types";

export const createRegReguler = createAsyncThunk(
    "createRegReguler",
    async (data: CreateRegRegulerRequest, thunkAPI) => {
        const config = {
            method: "post",
            url: "reg-reguler/submission",
            data: data
        };

        return api(config).then(
            (res: any) => {
                if (!res.data.CREATE_REGISTRATION.data.IdReg) {
                    return thunkAPI.rejectWithValue("Data tidak ditemukan");
                }
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);

export const getsRegReguler = createAsyncThunk(
    "getsRegReguler",
    async (params: GetsRegRegulerRequest, thunkAPI) => {
        const config = {
            method: "get",
            url: "reg-reguler/submission",
            params
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);

const RegistrationRegulerSlice = createSlice({
    name: "RegistrationRegulerSlice",
    initialState: {
        dataRegReguler: {} as CreateRefRegulerResponse,
        listRegReguler: { GETS_REGISTRATION: { data: [] as DataRegistration[] } } as GetsRegRegulerResponse,

        isFetching: false,

        isSuccessCreateRegReguler: false,
        isSuccessGetsRegReguler: false,

        isErrorCreateRegReguler: false,
        isErrorGetsRegReguler: false,

        errorMessage: "" as string,
    },
    reducers: {
        clearStateRegReguler: (state, action) => {
            state.isFetching = false;

            state.isSuccessCreateRegReguler = false;
            state.isSuccessGetsRegReguler = false;

            state.isErrorCreateRegReguler = false;
            state.isErrorGetsRegReguler = false;

            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {

        // createRegReguler
        builder.addCase(createRegReguler.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.isSuccessCreateRegReguler = true;
            state.dataRegReguler = payload;
            return state;
        });
        builder.addCase(createRegReguler.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isErrorCreateRegReguler = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(createRegReguler.pending, (state, action) => {
            state.isFetching = true;
        });

        // getsRegReguler
        builder.addCase(getsRegReguler.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.isSuccessGetsRegReguler = true;
            state.listRegReguler = payload;
            return state;
        });
        builder.addCase(getsRegReguler.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isErrorGetsRegReguler = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(getsRegReguler.pending, (state, action) => {
            state.isFetching = true;
        });

    },
});

export const { clearStateRegReguler } = RegistrationRegulerSlice.actions;
export default RegistrationRegulerSlice.reducer;
